import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SearchItem } from '@rivethealth/data/ui-search-item';
import { ObservableInput } from 'observable-input';
import { merge, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'chip-single',
  styleUrls: ['./chip-single.component.scss'],
  templateUrl: './chip-single.component.html',
})
export class ChipSingleComponent<T extends SearchItem> {
  @Input()
  @ObservableInput()
  search!: Observable<(term: string) => Promise<T[]>>;

  @Input()
  @ObservableInput()
  value!: Observable<string>;

  @Input()
  @ObservableInput()
  placeholder!: Observable<string>;

  @Input()
  @ObservableInput()
  loading!: Observable<boolean>;

  @Output()
  selected = new EventEmitter<T>();

  @Output()
  clear = new EventEmitter<void>();

  chipValue = merge(
    this.value,
    this.selected.pipe(map(item => item.text)),
    this.clear.pipe(
      map(() => {
        return '';
      }),
    ),
  );

  autoFocus = this.clear.pipe(
    map(() => {
      return true;
    }),
    startWith(false),
  );

  searching = merge(
    this.selected.pipe(
      map(() => {
        return false;
      }),
    ),
    this.clear.pipe(
      map(() => {
        return true;
      }),
    ),
    this.value.pipe(
      startWith(''),
      map(v => v === ''),
    ),
  );
}
